import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';

import PageWrapper from '../../components/PageWrapper';
import HeroSlider from './HeroSlider';
// import WelcomeSection from './WelcomeSection';
import TrustedSection from './TrustedSection';
import GallerySection from './GallerySection';
import VideoSection from './VideoSection';
import AreasSection from './AreasSection';
import ModelsSection from './ModelsSection';
import LeadCapture from './LeadCapture';

function Index({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <HeroSlider content={get(page, 'hero_section[0]')} />
      {
        get(page, 'trusted_section') &&
        <TrustedSection content={get(page, 'trusted_section')} />
      }
      {/* <WelcomeSection content={get(page, 'welcome_section[0]')} /> */}
      {
        get(page, 'gallery_section[0]') &&
        <GallerySection content={get(page, 'gallery_section[0]')} />
      }
      <VideoSection content={get(page, 'video_section[0]')} />
      <AreasSection />
      {
        get(page, 'model_section[0].published') &&
        <ModelsSection content={get(page, 'model_section[0]')} />
      }
      <LeadCapture content={page} />
    </PageWrapper>
  );
}

Index.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'home_page',
  },
  {
    ifMissing404: true,
  },
)(Index);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/index.js